import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import ContentComponent from './ContentComponent'
import QuoteContent from './QuoteContent'
import DirectionContentComponent from '../DirectionContentComponent'

type PostContentProps = {
  streamData: StreamData
  highlighting?: boolean
}

const PostContent = ({ streamData, highlighting }: PostContentProps) => {
  const [isTextHidden, setIsTextHidden] = useState<boolean>(true)

  const showHiddenText = () => {
    setIsTextHidden(false)
  }

  const {
    isTruncatedText,
    displayText,
    highlightedDisplayText,
    untruncatedDisplayText,
    untruncatedHighlightedDisplayText,
    isDisplayTextRtl,
    internalContents
  } = streamData
  const hasMoreText = isTextHidden && isTruncatedText!

  let text = highlighting ? highlightedDisplayText! : displayText!
  if (!isTextHidden) {
    text = highlighting ? untruncatedHighlightedDisplayText! : untruncatedDisplayText!
  }
  if (!isEmpty(internalContents)) {
    text = highlighting ? internalContents![0].highlightedText : internalContents![0].displayText
  }

  return (
    <>
      <DirectionContentComponent isRtl={isDisplayTextRtl}>
        <ContentComponent text={text} hasMoreText={hasMoreText} showHiddenText={showHiddenText} />
      </DirectionContentComponent>
      {streamData.parentText ? <QuoteContent streamData={streamData} /> : ''}
    </>
  )
}

export default PostContent
